import { DefaultValidator } from '../'
import { translateValidator } from '../../i18next/i18nextHelpers'
import { withDefaultValidator } from '../formValidators.utils'

const defaultTranslateKey = 'validator.validPhoneLength'

export const validPhoneLength = value => {
  const val =
    String(
      value
        .trim()
        .replace(/\s/g, '')
        .replace('-', '')
        .replace('+', '')
        .replace('(', '')
        .replace(')', ''),
    ).length >= 9 &&
    String(
      value
        .trim()
        .replace(/\s/g, '')
        .replace('-', '')
        .replace('+', '')
        .replace('(', '')
        .replace(')', ''),
    ).length <= 20
  return val
}

export const validPhoneLengthTranslated: DefaultValidator = withDefaultValidator(
  (localeKey?: string) =>
    translateValidator(validPhoneLength, localeKey || defaultTranslateKey),
)
